import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const inject = {
  install: function(Vue, options){
    const requireComponent = require.context(
      '../component', false, /base-[\w-]+\.vue$/
    )
    requireComponent.keys().forEach( fileName => {
      // Get component config
      const componentConfig = requireComponent(fileName)
      const componentName = upperFirst(
        camelCase(fileName.replace(/^\.\//,'').replace(/\.\w+$/, ''))
      )

      // Register component globally
      Vue.component(componentName, componentConfig.default || componentConfig)
    })
  }
}
export default inject



// WEBPACK FOOTER //
// ./src/inject/index.js